import { QueryFeature } from '../../../../config/queryClient';

enum QueryKey {
  Reconciliation = 'Reconciliation',
}

export const queryKeys = {
  reconciliation: (batchId: string | null, itemId: string | null) => [
    QueryFeature.PdfReconciliation,
    QueryKey.Reconciliation,
    batchId,
    itemId,
  ],
};
